import videojs from 'video.js';
import './timer.js';

class PromoCodeButton extends videojs.getComponent('Button') {
  constructor(player, options) {
    super(player, options);
    this.addClass('vjs-promo-code__button');
    this.promoCodeTimer = this.addChild('PromoCodeTimer', options);
    player.on('userinactive', () => {
      if (!player.paused() || player.hasClass('vjs-error') || player.hasClass('vjs-waiting')) {
        this.shift();
      }
    });
    player.on('useractive', () => {
      this.resetShift();
    });
    player.on('error', () => {
      if (player.hasClass('vjs-user-inactive')) {
        this.shift();
      }
    });
  }

  handleClick() {
    if (this.promoCodeTimer.isCountdownExpired) {
      this.player().getChild('PromoCodeModal').open();
    }
  }

  shift() {
    this.addClass('vjs-promo-code__button_shift');
    this.el().style.transform = `translateY(-${this.el().offsetTop}px)`;
  }

  resetShift() {
    this.removeClass('vjs-promo-code__button_shift');
    this.el().style.transform = '';
  }
}

videojs.registerComponent('PromoCodeButton', PromoCodeButton);

